import Layout from '../Components/Layout'
import { NavLink, useSearchParams} from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import RandomLogo from '../Components/RandomLogo';
import CompanyLogo from '../Components/CompanyLogo';
import OverflowToolTip from '../Components/shared/OverflowToolTip';
import Loader from '../Components/Loader';
import { Pagination } from 'antd';
import {TableDataContext} from '../Contexts/TableDataContext';
import { cubejsApi } from '..';
import SortIcon from 'mdi-react/SortIcon'
import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import { routeNames } from '../routeSegments';
import FilterTags from "../Components/QueryBuilder/Components/FilterTags";


/** The above component is used to build a query for retrieving data from a
database. It uses the Cube.js library to interact with the database and retrieve the desired data
based on the specified parameters. */
function QueryBuilder() {
    // console.log(location.state.filter,"jkjnkjkij");
    const { advancedSearchCurrentPage,setAdvancedSearchCurrentPage} = useContext(TableDataContext)
    // const [isLoading, setIsLoading] = useState(false)
    const [companyData, setCompanyData] = useState();
    const [totalCompany, setTotalCompany] = useState(1)
    const [sort, setSort] = useState({ order: "asc", orderBy: "Pecompanies.companyname" })
    const [searchParams, setSearchParams] = useSearchParams()
    const id = searchParams.get('id')

    const [PEVCTableHeader, setPEVCTableHeader] = useState(
        [
            { accessor: 'Pecompanies.companyname', label: 'Company' },
            { accessor: 'profile_flat.business_desc', label: 'Description' },
            { accessor: 'profile_flat.industry', label: 'Industry' },
            { accessor: 'profile_flat.sector', label: 'Sector' },
            { accessor: 'Pecompanies.yearfounded', label: 'Year Founded' }
        ]
    );
    
    const currentPageTable = (value) => {
      setAdvancedSearchCurrentPage(value)
      serachResult(value, sort.orderBy, sort.order)
    }
  
    useEffect (() => {
      findTotalCount()
      serachResult("1", sort.orderBy, sort.order)
    },[])
  
    const findTotalCount = () => {
        const query0 = totalCount();
  
        // setIsLoading(true);
        cubejsApi.load(query0
        )
          .then((result) => {
            // console.log('result', result.loadResponse.results[0].data[0]["Pecompanies.count_of_companyname"]);
            setTotalCompany(result.loadResponse.results[0].data[0]["Pecompanies.count_of_companyname"]);
          }) 
    }

    const serachResult = (page, accessor, order) => {
      // setrefineSearchFilters(1)
      setCompanyData()
      // setIsLoading(true);
      const query0 = generateCubeQuery(page, accessor, order);
  
      // setIsLoading(true);
      cubejsApi.load(query0
      )
        .then((result) => {
          // console.log('result', result.loadResponse.results[0].data);
          setCompanyData(result.loadResponse.results[0].data);
          // setIsLoading(false)
        })  
  
    }

    function totalCount() {
        const cubeQuery = {
          timeDimensions: [],
            measures: [
              "Pecompanies.count_of_companyname"
            ],
            order: {
              "Pecompanies.companyname": "asc",
            },
            segments:["Pecompanies.pecompanies_seg"],
          filters: JSON.parse(localStorage.getItem(id))
        };    
         if(JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.SPV') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.investors' ) || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.Amountm') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.Amount_inr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.amountM') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.amountInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.date') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.exitStatus') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.stage') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.round') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.priceToBook') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.preMoneyValuationInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.revenueMultiplePre') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.ebitdaMultiplePre') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.patMultiplePre') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.postMoneyValuationInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.revenueMultiplePost') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.ebitdaMultiplePost') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.patMultiplePost') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.enterpriseValuationInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.revenueMultipleEv') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.ebitdaMultipleEv') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.patMultipleEv')){
        cubeQuery['segments'].push(
          "Pecompanies.dealtype"
        )
      }
      else if(JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_amount') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_date') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.exit_status') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_type') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_sub_type') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.company_valuation') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.revenue_multiple') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.ebitda_multiple') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.pat_multiple')){
        cubeQuery['segments'].push(
          "Pecompanies.exitsOnly"
        )
      }
        return cubeQuery;
      }
  
    function generateCubeQuery(page, orderBy, order) {
      const cubeQuery = {
        timeDimensions: [],
        order: {
            [orderBy]: order,
        },
        dimensions: [
          "Pecompanies.companyname",
          "Pecompanies.yearfounded",
          "PecompanyLogo.iconPath",
          "profile_flat.business_desc",
          "profile_flat.industry",
          "profile_flat.sector",
          "Pecompanies.PECompanyId"
          // "DealFlat.amountM",
          // "PecompanyTagCrosstabVw.tags",
          // "DealFlat.SPV"
        ],
        segments:["Pecompanies.pecompanies_seg"],
        filters: JSON.parse(localStorage.getItem(id)),
        // limit: 20
        limit: 10,
        offset: page=="1"?0:10*(page-1)
      };
      if(JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.SPV') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.investors' ) || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.Amountm') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.Amount_inr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.amountM') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.amountInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.date') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.exitStatus') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.stage') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.round') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.priceToBook') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.preMoneyValuationInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.revenueMultiplePre') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.ebitdaMultiplePre') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.patMultiplePre') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.postMoneyValuationInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.revenueMultiplePost') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.ebitdaMultiplePost') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.patMultiplePost') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.enterpriseValuationInr') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.revenueMultipleEv') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.ebitdaMultipleEv') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'DealFlat.patMultipleEv')){
        cubeQuery['segments'].push(
          "Pecompanies.dealtype"
        )
      }
      else if(JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_amount') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_date') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.exit_status') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_type') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.deal_sub_type') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.company_valuation') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.revenue_multiple') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.ebitda_multiple') || JSON.parse(localStorage.getItem(id)).find(o => o.member === 'exit_investment_flat.pat_multiple')){
        cubeQuery['segments'].push(
          "Pecompanies.exitsOnly"
        )
      }
  
      return cubeQuery;
    }

    const filtersFromLocalStorage = JSON.parse(localStorage.getItem(id));

      const handleSort = (accessor, order) => {
        setSort((prevSort) => ({
            order: prevSort.order === 'asc' && prevSort.orderBy === accessor ? 'desc' : 'asc',
            orderBy: accessor,
          }))
        serachResult(advancedSearchCurrentPage, accessor, sort.order === 'asc' && sort.orderBy === accessor ? 'desc' : 'asc')
      }
    
    const onClose = (value) => {
      console.log(value);
      const updatedData = filtersFromLocalStorage
        .map((item) => {
        if (item.values && Array.isArray(item.values)) {
          item.values = item.values.filter((val) => val !== value);

          if (item.values.length === 0) {
            return null;
          }
        }

        return item;
      })
      .filter((item) => item !== null);
    console.log(updatedData);

    localStorage.setItem(`${id}`, JSON.stringify(updatedData));
    serachResult("1", sort.orderBy, sort.order);
    findTotalCount();
  };
  
  const deleteFilterByMember = (member) => {
    const updatedData = filtersFromLocalStorage.filter((item) => {
      return item.member !== member || (item.values && item.values.length <= 3);
    });

    console.log(updatedData, member);

    localStorage.setItem(`${id}`, JSON.stringify(updatedData));

    serachResult("1", sort.orderBy, sort.order);
    findTotalCount();
  };
  
    return (
        <div>
          <Layout>
              <div className="mt-[3.5rem]">
                {/* <QueryBuilderTabs /> */}
                {/* <TableTabTable filter={location.state.filter}/> */}
                <FilterTags
                  filtersFromLocalStorage={filtersFromLocalStorage}
                  onClose={onClose}
                  deleteFilterByMember={deleteFilterByMember}
                />                  
      {/* <h2> Table Rendering </h2> */}
      <div className="md:col-span-4 col-span-5">
        <div className="lg:col-span-4">
          <div className="scrollbar ">
            <div className={"overflow-x-auto scrollbar rounded rounded-[6px] rounded-t-none shadow-[0_2px_6px_0_rgba(0,0,0,0.08)] m-3 " + (companyData?.length > 5 ? '' : 'pr-2')}>

              <table className="md:pl-5 md:pr-5 pl-5 pr-[16rem]  listPage table w-full p-1 bg-grey-50 divide-y" width="50%">
                <thead className="bg-[#EBEBEB] text-[11pt] leading-[16pt] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666]  text-left"
                >
                    {PEVCTableHeader.map((column, i) => {
                      const sortIcon = () => {
                        if (column.accessor === sort.orderBy) {
                          if (sort.order === 'asc') {
                            return <SortDescendingIcon className="pl-2 block h-[15px]" />
                          }
                          return <SortAscendingIcon className="pl-2 block h-[15px]" />
                        } else {
                          return <SortIcon className="pl-2 block h-[15px] " />
                        }
                      }
                      return (
                        <th className={"md:pl-5 md:pr-5 px-[1rem] py-2 pr-[11rem] "} key={i}>
                          <span className='flex'><OverflowToolTip component={<a className='cursor-text hover:text-[#000000]'>{column.label ? column.label : "--"}</a>} />
                              <button onClick={() => handleSort(column.accessor, sort.order)}>{sortIcon()}</button>
                         </span>
                        </th>
                      )
                    })}
                </thead>
                <tbody className='text-[11pt] leading-[12pt] lg:text-[14px] lg:leading-[16px] text-[#333333] text-left font-sans_book_body'>
                  {companyData ?
                 companyData.length > 0 ? (
                  companyData?.map((row, i) => {
                    // console.log(row,'row data');
                    return (
                      <tr key={i} className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]   border-b bg-white " >
                         <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                         {/* {row['CfsFlat.logopath'] == '' ? 'empty' : 'No empty'} */}
                         {row["PecompanyLogo.iconPath"] == "default.png" || row["PecompanyLogo.iconPath"] == "/default.png" || !row["PecompanyLogo.iconPath"] ?
                                    <RandomLogo name={row['Pecompanies.companyname']} />
                                    :
                                    <CompanyLogo name={row['Pecompanies.companyname']} page="company page" logo={row["PecompanyLogo.iconPath"]} />
                                  }
                                 <OverflowToolTip 
                                  className="max-w-[15rem] lg:max-w-[20rem] 2xl:max-w-[30rem] overflow-x-clip overflow-ellipsis" 
                                  component={<NavLink className="hover:text-[#BC8B20] text-[#333333]" to={routeNames.peCompanyFundById(row['Pecompanies.PECompanyId'])}>{row['Pecompanies.companyname'] ? row['Pecompanies.companyname'] : "--"}</NavLink>}
                                   />
                          </td>
                          <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                          <OverflowToolTip 
                                  className="max-w-[15rem] lg:max-w-[20rem] 2xl:max-w-[30rem] overflow-x-clip overflow-ellipsis" 
                                  component={<a className='hover:text-[#000000] cursor-text '>{row['profile_flat.business_desc'] ? row['profile_flat.business_desc'] : "--"}</a>}
                                   />
                          </td>
                          <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                          <p className='cursor-text'>{row['profile_flat.industry']?row['profile_flat.industry']:"--"}</p></td>
                          <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                          {/* {row['profile_flat.sector']?row['profile_flat.sector']:"--"} */}
                          <OverflowToolTip 
                                  className="max-w-[15rem] lg:max-w-[20rem] 2xl:max-w-[30rem] overflow-x-clip overflow-ellipsis" 
                                  component={<a className='hover:text-[#000000] cursor-text '>{row['profile_flat.sector'] ? row['profile_flat.sector'] : "--"}</a>}
                                   />
                          </td>
                          <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center cursor-text">
                          <p className='cursor-text'>{row['Pecompanies.yearfounded']?row['Pecompanies.yearfounded']:"--"}</p></td>
                          {/* <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center"
                          >{row['Pecompanies.region']?row['Pecompanies.region']:"--"}</td> */}
                           {/* <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                          {row['DealFlat.amountM']?row['DealFlat.amountM']:"--"}</td>

                          <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                          {row['PecompanyTagCrosstabVw.tags']?row['PecompanyTagCrosstabVw.tags']:"--"}</td>

                          <td className="md:w-[20%] px-5 py-3 leading-[2rem] font-sans_book_body items-center justify-center">
                          {row['DealFlat.SPV']?row['DealFlat.SPV']:"--"}</td> */}

                          
                      </tr>
                    )
                  }))
                  
                   : (
                    <tr>
                      <td colSpan="5" className="py-3 text-center">No Records Found</td>
                    </tr>
                  )
                  :
                  <div className='sticky left-[50%] py-[2rem]'><Loader /></div>}
                </tbody>
              </table>


            </div>
          </div>
        </div>
      </div>
      <center className='my-[1rem]'><Pagination defaultCurrent={1} total={totalCompany} onChange={currentPageTable}/></center>

                </div>
            </Layout>
        </div>
    )
}

export default QueryBuilder
